import SelectInput from './Select'
export default SelectInput